<template>
  <div class="ws-data-table-with-title">
    <div class="ws-data-table-with-title__title">
      {{ title }}
    </div>
    <div class="ws-data-table-with-title__subtitle-wrap">
      <p class="ws-data-table-with-title__subtitle">
        {{ subtitle }}
      </p>
      <p class="ws-data-table-with-title__subtitle">
        {{ remark }}
      </p>
    </div>
    <div class="ws-data-table-with-title__table">
      <DataTable
        v-if="_showDataTable"
        :isloading="isloading"
        :table-overflow="tableOverflow"
        :column-header="columnHeader"
        :row-data="rowData"
        @click="$_recordPopupOpen($event)"
        @menu-item-click="$_menuItemClick($event)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "WsDataTableWithTitle001",
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
    tableOverflow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
    columnHeader: {
      type: Array,
      default() {
        return [];
      },
    },
    rowData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    _showDataTable() {
      if (!this.isloading && (!this.rowData || !this.rowData.length)) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    $_recordPopupOpen($event) {
      this.$emit("click", $event);
    },
    $_menuItemClick($event) {
      this.$emit("menu-item-click", $event);
    },
  },
};
</script>